module.exports = __webpack_public_path__ + "img/cg_old.dbe4446a.png";